import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import CSVReader from 'react-csv-reader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { EmployeeSchemaObject } from '../EmployeeSchema';
import divisionService from '../../Devision/services';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../utils/CommonParams';
import { MultiSelect } from "../../../Common/multiSelect";
import MaterialTable from "material-table";
import Switch from '@material-ui/core/Switch';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const screenCode = 'EMPLOYEE';

export function EmployeeCardAddEdit(props) {

    const [selectedOptions, setSelectedOptions] = useState([]);
    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(allHaverstingJobType);
        } else {
            handleClearOptions();
        }
    };
    const { screen } = props.location;
    const [title, setTitle] = useState("Add Employee");
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [isChanged, setIsChanged] = useState(0);
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [subordinateList, setSubordinateList] = useState([]);
    const [employeeCategories, setEmployeeCategories] = useState([]);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [collectionCategory, setCollectionCategory] = useState();
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [employeeSubCategories, setEmployeeSubCategories] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [allHaverstingJobType, setHaverstingJobType] = useState([]);
    const [employee, setEmployee] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        employeeCode: '',
        employeeTypeID: '0',
        employeeCategoryID: '0',
        title: '0',
        firstName: '',
        secondName: '',
        lastName: '',
        gender: '0',
        dateOfBirth: '',
        nic: '',
        epfNo: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        countryCode: '0',
        homePhoneNo: '',
        officePhoneNo: '',
        mobileNo: '',
        email: '',
        question: '',
        answer: '',
        collectionCategoryID: '0',
        isSupplementary: false,
        registrationNumber: '',
        nameToBePrinted: '',
        employeeSubCategoryID: '0',
        designationID: '0',
        maritalStatusID: '0',
        raceID: '0',
        religionID: '0',
        cardNumber: ''
    });
    const [state, setState] = useState({
        isSupplementary: false,
    });
    const [subordinators, setSubordinators] = useState({
        subordinateCode: '',
        subordinateName: ''
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    const schema = Joi.object(EmployeeSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            getPermissions(),
            getSelectedEmployeeData(),
            getEmployeeJobTypesData(),
            getSubordinatorDetails()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [employee.groupID])

    useEffect(() => {
        trackPromise(
            getEmployeeSubCategoriesForDropdown(),
            getDesignationsForDropdown()
        )
    }, [employee.employeeCategoryID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointIDForDropdown()
        )
    }, [employee.employeeSubCategoryID]);

    useEffect(() => {
        trackPromise(
            getallAvailableHaverstingJobTypeForDropdown()
        )
    }, [employee.collectionPointID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITEMPLOYEE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setEmployee({
            ...employee,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
        getEmployeeTypesForDropdown();
        getEmployeeCategoriesForDropdown();

        if (data && edit) {
            setTitle("Edit Employee");
            setButtonName("Update");
            setIsEditScreen(true);
        } else {
            setTitle("Add Employee");
        }
    }

    async function getSelectedEmployeeData() {
        const data = await services.GetEemployeeByID(id);
        if (data[0] !== undefined)
            setEditScreenData(data[0]);
    }

    async function getEmployeeJobTypesData() {
        let data = await services.GetEemployeeJobTypeByID(id);

        var options = []
        for (let item of Object.entries(data)) {
            options.push({ label: item[1]["haverstingJobTypeName"], value: item[1]["haverstingJobTypeID"] });
        }
        setSelectedOptions(options);
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEmployeeTypesForDropdown() {
        const result = await services.GetEmployeeTypesData();
        setEmployeeTypes(result);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(employee.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionPointIDForDropdown() {
        const collectionPoints = await services.GetCollectionPointsByCpCategoryandOpEntity(employee.operationEntityID, employee.employeeSubCategoryID);
        setCollectionPoints(collectionPoints);
    }

    async function getEmployeeCategoriesForDropdown(params) {
        const employeeCategories = await services.GetEmployeeCategoriesData();
        setEmployeeCategories(employeeCategories);
    }

    async function getEmployeeSubCategoriesForDropdown(params) {
        const employeeCategories = await services.GetEmployeeSubCategoriesData(employee.employeeCategoryID);
        setEmployeeSubCategories(employeeCategories);
    }

    async function getDesignationsForDropdown(params) {
        const employeeDesignations = await services.GetEemployeeDesignationsData(employee.employeeCategoryID);
        setDesignations(employeeDesignations);
    }

    async function getallAvailableHaverstingJobTypeForDropdown() {
        let filteredData = await services.getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID(employee.collectionPointID, employee.employeeTypeID);

        var options = []
        for (let item of Object.entries(filteredData)) {
            options.push({ label: item[1]["haverstingJobTypeName"], value: item[1]["haverstingJobTypeID"] });
        }
        setHaverstingJobType(options);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>);
            }
        }
        return items;
    }

    function handleChange(e) {

        const target = e.target
        const value = target.name === 'isSupplementary' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, EmployeeSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setEmployee({
            ...employee,
            [e.target.name]: value
        });

        setErrors(error);
    }

    function setEditScreenData(data) {
        setEmployee({
            groupID: data.groupID,
            operationEntityID: data.operationEntityID,
            collectionCategoryID: data.collectionCategoryID,
            collectionPointID: data.collectionPointID,
            employeeCode: data.employeeCode,
            employeeTypeID: data.employeeTypeID,
            employeeCategoryID: data.employeeCategoryID,
            title: data.titleID,
            firstName: data.firstName,
            secondName: data.secondName,
            lastName: data.lastName,
            gender: data.genderID,
            dateOfBirth: data.dateOfBirth.split('T')[0],
            nic: data.nic,
            epfNo: data.epfNo,
            address1: data.address1,
            address2: data.address2,
            address3: data.address3,
            city: data.city,
            countryCode: data.countryID,
            homePhoneNo: data.homePhoneNo,
            officePhoneNo: data.officePhoneNo,
            mobileNo: data.mobileNo,
            email: data.email,
            question: data.question,
            answer: data.answer,
            isSupplementary: data.isSupplementary,
            registrationNumber: data.registrationNumber,
            nameToBePrinted: data.nameToBePrinted,
            employeeSubCategoryID: data.collectionPointCategoryID.toString(),
            designationID: data.designationID.toString(),
            maritalStatusID: data.maritalStatusID.toString(),
            raceID: data.raceID.toString(),
            religionID: data.religionID.toString(),
            cardNumber: data.cardNumber
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, employee);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});

        if (errorMessages) return

        var employeeDetails = {
            employeeID: (data && edit) ? parseInt(id) : 0,
            groupID: parseInt(employee.groupID),
            operationEntityID: parseInt(employee.operationEntityID),
            collectionPointID: parseInt(employee.collectionPointID),
            employeeTypeID: employee.employeeTypeID,
            employeeCategoryID: employee.employeeCategoryID,
            employeeCode: employee.employeeCode,
            titleID: employee.title,
            firstName: employee.firstName,
            secondName: employee.secondName,
            lastName: employee.lastName,
            genderID: employee.gender,
            dateOfBirth: employee.dateOfBirth,
            epfNo: employee.epfNo,
            nic: employee.nic,
            address1: employee.address1,
            address2: employee.address2,
            address3: employee.address3,
            city: employee.city,
            countryID: employee.countryCode,
            homePhoneNo: employee.homePhoneNo,
            officePhoneNo: employee.officePhoneNo,
            mobileNo: employee.mobileNo,
            email: employee.email,
            question: employee.question,
            answer: employee.answer,
            isSupplementary: state.isSupplementary,
            registrationNumber: employee.registrationNumber,
            nameToBePrinted: employee.nameToBePrinted,
            collectionPointCategoryID: parseInt(employee.employeeSubCategoryID),
            designationID: parseInt(employee.designationID),
            maritalStatusID: parseInt(employee.maritalStatusID),
            raceID: parseInt(employee.maritalStatusID),
            religionID: parseInt(employee.religionID),
            userID: parseInt(tokenService.getUserIDFromToken()),
            JobTypeList: selectedOptions
        }
        let response;
        if (!edit) {
            response = await services.saveEmployee(employeeDetails);
        } else {
            response = await services.updateEmployee(employeeDetails);
        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/employee' });
                // workaround for fix not loading employee screen
                props.history.go();
            }, 1500);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setErrors({});
        setEmployee({
            ...employee,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            operationEntityTypeID: "0",
            collectionCategoryID: "0",
            collectionPointID: "0",
            employeeTypeID: '0',
            employeeCategoryID: '0',
            employeeCode: '',
            title: '',
            firstName: '',
            secondName: '',
            lastName: '',
            gender: '',
            dateOfBirth: '',
            nic: '',
            epfNo: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            countryCode: '',
            homePhoneNo: '',
            officePhoneNo: '',
            mobileNo: '',
            email: '',
            question: '',
            answer: '',
            isSupplementary: (isEditScreen) ? data.isSupplementary : '',
            registrationNumber: (isEditScreen) ? data.registrationNumber : '',
            nameToBePrinted: (isEditScreen) ? data.nameToBePrinted : '',
            employeeSubCategoryID: '0',
            designationID: '0',
            maritalStatusID: '0',
            raceID: '0',
            religionID: '0'
        })
    }

    function handleChangeSubordinator(e) {
        const target = e.target
        const value = target.value;
        setSubordinators({
            ...subordinators,
            [e.target.name]: value
        });
    }

    async function AddSubordinator() {

        if (subordinators.subordinateCode == "" || subordinators.subordinateName == "") {
            setMessageModel({
                ...messageModel, hidden: false, type: "Error",
                disciption: "Please Enter The Subordinate Code And Subordinate Name"
            })
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 1500);
            return;
        }

        var model = {
            subordinateCode: subordinators.subordinateCode,
            subordinateName: subordinators.subordinateName,
            employeeID: parseInt(id),
            groupID: parseInt(employee.groupID),
            operationEntityID: parseInt(employee.operationEntityID),
            userID: parseInt(tokenService.getUserIDFromToken()),
        };
        var response = await services.SaveEmployeeSubordinator(model);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        setTimeout(() => {
            setMessageModel({ ...messageModel, hidden: true });
        }, 1500);
        getSubordinatorDetails();
    }

    async function getSubordinatorDetails() {
        var response = await services.GetEmployeeSubordinators(parseInt(id));
        setSubordinateList(response);
    }

    async function handleDeleteClick(data) {
        var model = {
            employeeSubordinatorID: data.employeeSubordinatorID,
            userID: parseInt(tokenService.getUserIDFromToken()),
        };
        var response = await services.DeleteEmployeeSubordinator(model);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        setTimeout(() => {
            setMessageModel({ ...messageModel, hidden: true });
        }, 1500);
        getSubordinatorDetails();
    }

    async function handleInActiveClick(data) {
        var model = {
            employeeSubordinatorID: data.employeeSubordinatorID,
            isActive: data.isActive == true ? false : true,
            userID: parseInt(tokenService.getUserIDFromToken()),
        };
        var response = await services.InActiveEmployeeSubordinator(model);
        if (response.statusCode === "Success") {
            getSubordinatorDetails();
        }

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path={screen === "empScreen" || screen === undefined ? "/employee" : "/rsmemployee"}
                            />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Group *"
                                            id="groupID"
                                            name="groupID"
                                            value={employee.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled || isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Operation Entity *"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={employee.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select operation Entity--</option>
                                            {generateDropDownMenu(operationEntity)}
                                        </TextField>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Type *"
                                            id="employeeTypeID"
                                            name="employeeTypeID"
                                            value={employee.employeeTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select employee type--</option>
                                            {generateDropDownMenu(employeeTypes)}
                                        </TextField>
                                        {errors["employeeTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeTypeID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">

                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Category *"
                                            id="employeeCategoryID"
                                            name="employeeCategoryID"
                                            value={employee.employeeCategoryID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select employee category--</option>
                                            {generateDropDownMenu(employeeCategories)}
                                        </TextField>
                                        {errors["employeeCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Sub Category *"
                                            id="employeeSubCategoryID"
                                            name="employeeSubCategoryID"
                                            value={employee.employeeSubCategoryID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select employee sub category--</option>
                                            {generateDropDownMenu(employeeSubCategories)}
                                        </TextField>
                                        {errors["employeeSubCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeSubCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Collection Point *"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={employee.collectionPointID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Collection Point--</option>
                                            {generateDropDownMenu(collectionPoints)}
                                        </TextField>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Designation *"
                                            id="designationID"
                                            name="designationID"
                                            value={employee.designationID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Designation--</option>
                                            {generateDropDownMenu(designations)}
                                        </TextField>
                                        {errors["designationID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["designationID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Employee Code *"
                                            name="employeeCode"
                                            id="employeeCode"
                                            value={employee.employeeCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["employeeCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeCode"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <MultiSelect
                                            items={allHaverstingJobType}
                                            getOptionLabel={getOptionLabel}
                                            getOptionDisabled={getOptionDisabled}
                                            selectedValues={selectedOptions}
                                            label="Select Job Type"
                                            placeholder="Job Type"
                                            selectAllLabel="Select all"
                                            onToggleOption={handleToggleOption}
                                            onClearOptions={handleClearOptions}
                                            onSelectAll={handleSelectAll}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Employee Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField select fullWidth
                                            label="Title *"
                                            id="title"
                                            name="title"
                                            value={employee.title}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Title--</option>
                                            <option value="1">Mr.</option>
                                            <option value="2">Mrs.</option>
                                            <option value="3">Ms.</option>
                                        </TextField>
                                        {errors["title"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["title"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="First Name *"
                                            name="firstName"
                                            id="firstName"
                                            value={employee.firstName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["firstName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["firstName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Second Name"
                                            name="secondName"
                                            id="secondName"
                                            value={employee.secondName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["secondName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["secondName"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Last Name"
                                            name="lastName"
                                            id="lastName"
                                            value={employee.lastName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["lastName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["lastName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField select fullWidth
                                            label="Gender *"
                                            id="gender"
                                            name="gender"
                                            value={employee.gender}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Gender--</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </TextField>
                                        {errors["gender"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gender"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Marital Status *"
                                            id="maritalStatusID;"
                                            name="maritalStatusID"
                                            value={employee.maritalStatusID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Marital Status--</option>
                                            <option value="1">Married</option>
                                            <option value="2">Single</option>
                                        </TextField>
                                        {errors["maritalStatusID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["maritalStatusID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Date Of Birth *"
                                            name="dateOfBirth"
                                            id="dateOfBirth"
                                            value={employee.dateOfBirth}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="NIC *"
                                            name="nic"
                                            id="nic"
                                            value={employee.nic}
                                            type="text"
                                            maxLength="12"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["nic"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nic"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="EPF No"
                                            name="epfNo"
                                            id="epfNo"
                                            value={employee.epfNo}
                                            type="text"
                                            maxLength="12"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["epfNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["epfNo"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Religion *"
                                            id="religionID"
                                            name="religionID"
                                            value={employee.religionID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Religion--</option>
                                            <option value="1">Buddhist</option>
                                            <option value="2">Catholic</option>
                                            <option value="3">Hindu</option>
                                            <option value="4">Islam</option>
                                            <option value="5">Other</option>
                                        </TextField>
                                        {errors["religionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["religionID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Race *"
                                            id="raceID"
                                            name="raceID"
                                            value={employee.raceID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Race--</option>
                                            <option value="1">Sinhala</option>
                                            <option value="2">Tamil</option>
                                            <option value="3">Muslim</option>
                                            <option value="4">Other</option>
                                        </TextField>
                                        {errors["raceID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["raceID"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Address" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address1 "
                                            name="address1"
                                            id="address1"
                                            value={employee.address1}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address1"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address1"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 2"
                                            name="address2"
                                            id="address2"
                                            value={employee.address2}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address2"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address2"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 3"
                                            name="address3"
                                            id="address3"
                                            value={employee.address3}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address3"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address3"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="City"
                                            name="city"
                                            id="city"
                                            value={employee.city}
                                            type="text"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["city"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["city"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Country *"
                                            id="countryCode"
                                            name="countryCode"
                                            value={employee.countryCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Country--</option>
                                            <option value="1">Afghanistan</option>
                                            <option value="2">Canada</option>
                                            <option value="3">France	</option>
                                            <option value="4">	Hungary</option>
                                            <option value="5">	Sri Lanka</option>
                                            <option value="6">	Ukraine</option>
                                        </TextField>
                                        {errors["countryCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["countryCode"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card">
                            <PageHeader
                                title="Contact" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Home Phone No"
                                            name="homePhoneNo"
                                            id="homePhoneNo"
                                            value={employee.homePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["homePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["homePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Office Phone No"
                                            name="officePhoneNo"
                                            id="officePhoneNo"
                                            value={employee.officePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["officePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["officePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Mobile No"
                                            name="mobileNo"
                                            id="mobileNo"
                                            value={employee.mobileNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["mobileNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["mobileNo"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">

                                        <TextField fullWidth label="Email"
                                            name="email"
                                            id="email"
                                            value={employee.email}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["email"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["email"]}</FormHelperText>}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Verification" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Question"
                                            name="question"
                                            id="question"
                                            value={employee.question}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />

                                        {errors["question"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["question"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Answer"
                                            name="answer"
                                            id="answer"
                                            value={employee.answer}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />

                                        {errors["answer"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["answer"]}</FormHelperText>}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Card Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Registration Number *"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={employee.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Name to be printed *"
                                            name="nameToBePrinted"
                                            id="nameToBePrinted"
                                            value={employee.nameToBePrinted}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["nameToBePrinted"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nameToBePrinted"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Card Number"
                                            name="cardNumber"
                                            id="cardNumber"
                                            value={employee.cardNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["nameToBePrinted"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nameToBePrinted"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <label>Supplementary Card</label>
                                    <div className="form-group row">
                                        <div className="col-md-4 pb-1">
                                            <input
                                                className="mr-2"
                                                id="isSupplementary"
                                                switch="none"
                                                type="checkbox"
                                                name="isSupplementary"
                                                onChange={(e) => handleChange(e)}
                                                checked={employee.isSupplementary}
                                            />
                                            <label htmlFor="isSupplementary" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isEditScreen == true ?
                            <div className="card">
                                <PageHeader
                                    title="Subordinators Details" />
                                <div className="card-body">
                                    <div className="row row-top-gap">
                                        <div className="col-md-4 pb-1">
                                            <TextField fullWidth label="Subordinate Code *"
                                                name="subordinateCode"
                                                id="subordinateCode"
                                                value={subordinators.subordinateCode}
                                                type="text"
                                                onChange={(e) => handleChangeSubordinator(e)}
                                            />
                                            {errors["subordinateCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["subordinateCode"]}</FormHelperText>}
                                        </div>
                                        <div className="col-md-4 pb-1">
                                            <TextField fullWidth label="Subordinate Name *"
                                                name="subordinateName"
                                                id="subordinateName"
                                                value={subordinators.subordinateName}
                                                type="text"
                                                onChange={(e) => handleChangeSubordinator(e)}
                                            />
                                            {errors["subordinateName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["subordinateName"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    <div>
                                        <input
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={AddSubordinator}
                                            value='Add'
                                        />
                                    </div>
                                    {subordinateList.length != 0 ?
                                        <div className="table-responsive row-top-gap" style={{ marginTop: '50px' }}>
                                            <MaterialTable
                                                title="Multiple Actions Preview"
                                                columns={[
                                                    { title: 'Subordinate Code', field: 'subordinateCode', headerStyle: { fontWeight: "bold" } },
                                                    { title: 'Subordinate Name', field: 'subordinateName', headerStyle: { fontWeight: "bold" } },
                                                    {
                                                        title: 'Is Active', field: 'isActive', headerStyle: { fontWeight: "bold" },
                                                        type: "boolean",
                                                        render: (data) => (
                                                            <Switch color="primary" checked={data.isActive} onClick={() => handleInActiveClick(data)} />
                                                        ),
                                                    },
                                                    {
                                                        title: 'Action', field: 'select', headerStyle: { fontWeight: "bold" },
                                                        render: (data) => (
                                                            <IconButton aria-label="delete" onClick={() => handleDeleteClick(data)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        ),
                                                    }
                                                ]}
                                                data={subordinateList}
                                                options={{
                                                    exportButton: false,
                                                    showTitle: false,
                                                    headerStyle: { textAlign: "left", height: '1%' },
                                                    cellStyle: { textAlign: "left" },
                                                    columnResizable: false,
                                                    actionsColumnIndex: -1
                                                }}
                                            />
                                        </div> : null}
                                </div>
                            </div> : null}
                    </div>
                    <div>
                        <input
                            disabled={validate(schema, employee)}
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                            value={buttonName}
                        />

                        <input type="reset" className="btn btn-warning pull-right"
                            onClick={clearState}
                            value="Clear"
                            hidden={isEditScreen}
                        />
                    </div>
                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </div>
            </div>
        </Fragment >
    );
}